import request from '@/utils/request.js'
// 获取token
export function loginApi (username, password, sysId) {
  return request({
    url: `/api/login/sys`,
    method: 'POST',
    data: {
      username: username,
      password: password,
      sysId: sysId
    }
  })
}
// 获取用户信息
export function getUserName (token) {
  return request({
    url: `/api/info/token`,
    method: 'POST',
    data: {
      token: token
    }
  })
}
// 获取菜单
export function getMenus (sysId) {
  return request({
    url: `/api/menus/sys/${sysId}`,
    method: 'GET'
  })
}
// 退出登录
export function logout (data) {
  return request({
    url: `/api/logout`,
    method: 'POST',
    data
  })
}

// 修改密码
export function editPassword (id, data) {
  return request({
    url: `/data/users/${id}/pass/`,
    method: 'PUT',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js